define('modules/lp_info/collections/page_variants',['require','exports','module','backbone','base/collection','../models/variant','../models/weight_update','env','common/models/date_model'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
      BaseCollection = require("base/collection"),
      Variant = require("../models/variant"),
      UpdateWeightCommand = require("../models/weight_update"),
      config = require("env"),
      DateModel = require("common/models/date_model");

  module.exports = BaseCollection.extend({
    initialize: function(models,options) {
      this.viewModel = new Backbone.Model();
      this.viewModel.set("page", options.page);
      var date = options.date || new DateModel();
      this.viewModel.set("date", date);
      if (!options.page.isNew()) {
        this.fetch({data: date.toJSON()});
      } else {
        this.listenTo(options.page, "sync", function() { this.fetch({data: date.toJSON()}); });
      }
      this.listenTo(date, "change", _.bind(function(){
        this.fetch({data: date.toJSON()});
      }, this));
      this.on("refresh", this.adjustWeights, this);
    },

    model: Variant,

    url: function() {
      return [config.apiHost, "pages", this.viewModel.get("page").id, "variants"].join("/");
    },

    debounceFetch: function() {
      var fetchfn = this.fetch;
      this.fetch = _.debounce(fetchfn, 500);
    },

    duplicateUrlFor: function(variant) {
      var baseUrl = this.url();
      return [baseUrl, variant.id, "copy"].join("/");
    },

    duplicateVariant: function(variant) {
      var pageId = variant.get("pages_id");
      this.duplicateOrCopyVariant(variant, pageId);
    },

    copyVariantTo: function(variant, pageId) {
      return this.duplicateOrCopyVariant(variant, pageId);
    },

    duplicateOrCopyVariant: function(variant, pageId) {
      var duplicate = variant.clone();
      duplicate.set("stats", {});
      duplicate.set("history", []);
      duplicate.unset("name");
      duplicate.set({
        id: undefined,
        weight: 0
      });
      duplicate.set("pages_id", pageId);
      duplicate.url = this.duplicateUrlFor(variant);
      duplicate.once("sync", function() {
        this.add(duplicate);
        delete duplicate.url;
      }, this);
      return duplicate.save();
    },

    getMainFor: function(platform) {
      var main = _.first(this.where({is_main: true, platform: platform}));
      return main;
    },

    getVariantsFor: function(platform) {
      return this.filter(function(variant){
        return !variant.get("is_main") && variant.get("platform") === platform && variant.get("active");
      });
    },

    getNonMainCount: function(){
      var nonMainVariants = this.filter(function(v){
        return !v.get("is_main") && v.get("active");
      });
      return nonMainVariants.length;
    },

    getDiscardedCount: function(){
      return this.filter(function(variant){
        return !variant.get("active");
      }).length;
    },

    discardVariant: function(variant){
      var platform = variant.get("platform"),
          mainVariant = this.getMainFor(platform),
          secondaryVariant = _.first(this.where({is_main: false, active: true, platform: platform}).filter(function(v){ return v.get("id") != variant.get("id"); })),
          weight = variant.get("weight");

      variant.set("weight", 0);
      if (variant.get("is_main")) {
        if (secondaryVariant) {
          weight += secondaryVariant.get("weight");
          secondaryVariant.save({
            weight: Math.min(100, weight)
          }, {
            patch: true
          });
        }
      } else {
        var other = mainVariant || secondaryVariant;
        if (other) {
          weight = mainVariant ? this.calculateMainWeight(platform) : weight + secondaryVariant.get("weight");
          other.save({
            weight: weight
          }, {
            patch: true
          });
        }
      }
      variant.save({ weight: 0, active: false }, {patch:true});
    },

    reactivateVariant: function(variant){
      var attrs = { active: true },
          platform = variant.get("platform");
      if (!this.getMainFor(platform) && !this.getVariantsFor(platform).length) attrs.weight = 100;
      variant.save(attrs, {patch: true});
    },

    promoteToMain: function(variant){
      var main = this.getMainFor(variant.get("platform"));
      if(!this.contains(variant)) { return; }
      main && main.set({"is_main": false});
      variant.save({"is_main": true}, {patch: true});
    },

    removeOldMain: function(platform, newWeight) {
      var main = _.first(this.where({"is_main": true, platform: platform})),
          oldMainWeight;
      if (main) {
        oldMainWeight = main.get("weight");
        //don't set is_main to false, it's not allowed by the backend
        if (!main) { return; }
        main.save({
          weight: newWeight
        }, {
          patch:true,
          success: function(model) {
            model.set("is_main", false);
          }
       });

      }
      return oldMainWeight;
    },

    setWeight: function(variant, weight, callback, error) {
      var platform = variant.get("platform"),
          updateWeightCommand = new UpdateWeightCommand({
            id: variant.get("pages_id")
          }),
          payload = {
            variantId: variant.get("id")
          };

      payload.weight = this.getMainFor(platform) ? weight : this.calculateWeightMargin(variant);

      updateWeightCommand.save(payload, {
        patch: true,
        success: _.bind(function(command, variants){
          _.each(variants, function(variant){
            this.get(variant.variantId).set("weight", variant.weight);
          }, this);
          callback();
        }, this),
        error: error
      });
    },

    calculateTotalWeight: function(platform) {
      return this.where({ active: true, platform: platform }).reduce(function(total, variant){
        return total + (+variant.get("weight"));
      }, 0);
    },

    calculateWeightMargin: function(variant) {
      var platform = variant.get("platform"),
          vWeight = this.calculateVariantsWeight(platform) - (+variant.get("weight"));
      return Math.max(0, 100 - Math.max(0, vWeight));
    },

    calculateVariantsWeight: function(platform){
      var relevant = this.where({active: true, platform: platform, is_main: false});
      return _.reduce(
               _.invoke(relevant, "get", "weight"),
               function(a, b) { return (+a)+(+b); },
               0
             );
    },

    calculateMainWeight: function(platform){
      return Math.max(0, 100 - this.calculateVariantsWeight(platform));
    },

    getInitDate: function() {
      return this.viewModel.get("date").getFirstDate();
    },

    getStats: function() {
      var stats = this.reduce(function(stats, model){
        var mStats = model.get("stats");
        return {
          visits: stats.visits + mStats.visits,
          visitors: stats.visitors + mStats.visitors,
          conversion: stats.conversion + mStats.conversion,
        };
      }, {
        visits: 0,
        visitors: 0,
        conversion: 0,
      });
      stats.crt = 100 * stats.conversion / stats.visitors;
      return stats;
    },
  });
});

